module.exports = __webpack_public_path__ + "static/dl2-stay-human_screen3-6af199c0e6a1d6d891afea63a3063af0.png";